<template>
  <div>
    <CCard class="bg-style2">
      <CCardHeader class="bg-gradient-dark text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem">
        <span class="font-weight-bold h6">
          <CIcon :name="icon" size="lg"/> {{ caption }}
        </span>
        
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol>
            <CDataTable
              :key="tableKey"
              v-if="tableItems.length"
              :items="tableItems"
              :fields="userFields"
              :hover="hover"
              :bordered="bordered"
              :small="small"
              :fixed="fixed"
              :items-per-page="small ? 50 : 15"
              :striped="striped"
              pagination
              :dark="dark"
            >
              <template #index="{ index }"><td>{{ index + 1 }}</td></template>
              <template #firstName="{ item }"><td>{{ item.firstName || 'ไม่มีชื่อ' }}</td></template>
              <template #email="{ item }"><td>{{ item.email || 'ไม่มีอีเมล' }}</td></template>

              <template #roles="{ item }">
                <td>
                  <span v-if="!item.roles || item.roles.length === 0" class="text-muted">ไม่มี role</span>
                  <template v-else>
                    <CButton
                      v-for="roleId in item.roles"
                      :key="roleId"
                      size="sm"
                      color="info"
                      shape="pill"
                      variant="outline"
                      class="mr-1 mb-1"
                      :disabled="loading"
                      @click="removeRole(item._raw, roleId)"
                      v-c-tooltip="{ content: 'ลบ Role นี้', placement: 'top' }"
                    >
                      {{ getRoleTitle(roleId) }} ✕
                    </CButton>
                  </template>
                </td>
              </template>

              <template #actions="{ item }">
                <td>
                  <CButton
                    color="info"
                    size="sm"
                    shape="pill"
                    variant="outline"
                    class="mr-1"
                    :disabled="loading"
                    @click="openAddRoleModal(item._raw)"
                    v-c-tooltip.hover.click="'เพิ่มสิทธิ์ผู้ใช้งาน'"
                  >
                    <CIcon name="cil-plus" />
                  </CButton>
                  <CButton
                    color="danger"
                    size="sm"
                    shape="pill"
                    variant="outline"
                    :disabled="loading"
                    @click="deleteUserConfirm(item._raw)"
                    v-c-tooltip.hover.click="'ลบผู้ใช้งาน'"
                  >
                    <CIcon name="cil-trash" />
                  </CButton>
                </td>
              </template>
            </CDataTable>

            <div v-else class="text-center p-3">
              <span v-if="loading">กำลังโหลดข้อมูลผู้ใช้งาน...</span>
              <span v-else>ไม่พบข้อมูลผู้ใช้งาน</span>
            </div>

            <div class="d-flex justify-content-end align-items-center p-0 mt-1 mb-1 mr-2">
                <CButton
                  :key="componentKey"
                  class="mr-1"
                  color="info"
                  size="sm"
                  shape="pill"
                  variant="outline"
                  :disabled="loading"
                  @click="openAddUserModal"
                  v-c-tooltip.hover.click="'เพิ่มผู้ใช้งานใหม่'"
                >
                  <CIcon name="cil-plus" />
                </CButton>
              </div>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

    <!-- Modal เพิ่ม Role -->
    <CModal
      title="เพิ่ม Role ผู้ใช้งาน"
      :show.sync="showRoleModal"
      :centered="true"
      class="modal-rounded"
    >
      <template #body-wrapper>
        <div style="padding: 1rem;">
          <div class="form-group">
            <label>เลือก Role</label>
            <select v-model="selectedRole" class="form-control">
              <option v-for="role in availableRoles" :key="role.roleId" :value="role.roleId">
                {{ role.title }}
              </option>
            </select>
          </div>
        </div>
      </template>
      <template #footer>
        <CButton class="mr-2" size="sm" color="danger" shape="pill" variant="outline" @click="closeRoleModal">
          <span class="font-weight-bold pr-1 pl-1"><CIcon name="cil-ban" size="sm"/> CANCEL </span>
        </CButton>
        <CButton size="sm" color="success" shape="pill" variant="outline" @click="confirmAddRole" :disabled="!selectedRole">
          <span class="font-weight-bold pr-1 pl-1"><CIcon name="cil-save" size="sm"/> SUBMIT </span>
        </CButton>
      </template>
    </CModal>

    <!-- Modal เพิ่มผู้ใช้งานใหม่ -->
    <CModal
      title="เพิ่มผู้ใช้งานใหม่"
      :show.sync="showAddUserModal"
      :centered="true"
      class="modal-rounded"
    >
      <template #body-wrapper>
        <div style="padding: 1rem;">
          <div class="form-group">
            <label>ชื่อ</label>
            <input class="form-control" v-model="newUser.firstName" placeholder="ชื่อผู้ใช้งาน" />
          </div>
          <div class="form-group">
            <label>อีเมล</label>
            <input class="form-control" v-model="newUser.email" placeholder="user@example.com" />
          </div>
          <!-- <div class="form-group">
            <label>รหัสผ่าน (ไม่บังคับ)</label>
            <input type="password" class="form-control" v-model="newUser.password" placeholder="ตั้งรหัสผ่าน" />
          </div> -->
          <div class="form-group">
            <label>กำหนด Role</label>
            <select v-model="newUser.role" class="form-control">
              <option v-for="role in availableRoles" :key="role.roleId" :value="role.roleId">{{ role.title }}</option>
            </select>
          </div>
        </div>
      </template>
      <template #footer>
        <CButton class="mr-2" size="sm" color="danger" shape="pill" variant="outline" @click="closeAddUserModal">
          <span class="font-weight-bold pr-1 pl-1"><CIcon name="cil-ban" size="sm"/> CANCEL </span>
        </CButton>
        <CButton size="sm" color="success" shape="pill" variant="outline" @click="confirmAddUser" :disabled="!newUser.email">
          <span class="font-weight-bold pr-1 pl-1"><CIcon name="cil-save" size="sm"/> SUBMIT </span>
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Swal from 'sweetalert2';

export default {
  name: "CMSManageUsers",
  props: {
    icon: { type: String, default: "cil-user" },
    caption: { type: String, default: "CMS จัดการผู้ใช้งาน" }
  },
  data() {
    return {
      tableKey: 0,
      userFields: [
        { key: 'index', label: '#', _style: 'width:60px' },
        { key: 'firstName', label: 'ชื่อ' },
        { key: 'email', label: 'อีเมล' },
        { key: 'roles', label: 'ตำแหน่ง/สิทธิ์' },
        { key: 'actions', label: 'การจัดการ', sorter: false, filter: false},
      ],
      availableRoles: [
        { roleId: 1, title: "Assets" },
        { roleId: 2, title: "Car" },
        { roleId: 3, title: "Admin" },
      ],
      // Modal Add Role
      showRoleModal: false,
      modalUser: null,
      modalUserName: '',
      selectedRole: null
  ,
      // Add User Modal
      showAddUserModal: false,
      newUser: { firstName: '', email: '', password: '', role: null },
    };
  },

   mounted() {
    // Force tooltip re-initialization
    this.$nextTick(() => {
      if (this.$el && this.$el.querySelectorAll) {
        const tooltips = this.$el.querySelectorAll('[data-tooltip]');
        tooltips.forEach(el => {
          // Trigger a small change to re-bind
          el.setAttribute('data-original-title', el.getAttribute('data-original-title'));
        });
      }
    });

    this.componentKey += 1;
  },

  computed: {
    ...mapGetters({
      users: "Auth/users",
      loading: "Auth/loading"
    }),
    safeUsers() {
      return Array.isArray(this.users) ? this.users : [];
    },
    tableItems() {
      return this.safeUsers.map(u => ({
        _id: u._id,
        firstName: this.getFirstName(u),
        email: this.getEmail(u),
        roles: this.getRoles(u),
        actions: '',
        _raw: u,
      }));
    }
  },
  created() {
    this.onInit();
  },
  methods: {
    ...mapActions("Auth", ["fetchUsers", "updateUser", "deleteUser", "createUser"]),
    async onInit() {
      await this.fetchUsers();
    },
    getFirstName(user = {}) {
      const fi = user.userInfo || user.userinfo || user.profile || {};
      if (Array.isArray(fi.firstName) && fi.firstName.length) return fi.firstName[0]?.value || "ไม่มีชื่อ";
      if (fi.firstName) return fi.firstName;
      if (fi.firstname) return fi.firstname;
      if (user.firstName) return user.firstName;
      return "ไม่มีชื่อ";
    },
    getEmail(user = {}) {
      // ตรวจสอบ email ที่ root level ก่อน
      if (user.email) return user.email;
      
      // ตรวจสอบ email ใน authen array
      if (user.authen && Array.isArray(user.authen) && user.authen.length > 0) {
        const firstAuth = user.authen[0];
        if (firstAuth && firstAuth.email) return firstAuth.email;
      }
      
      // ตรวจสอบ email ใน userinfo
      const fi = user.userInfo || user.userinfo || user.profile || {};
      if (fi.email) return fi.email;
      
      return "ไม่มีอีเมล";
    },
    getRoles(user) {
      const allRoles = Array.isArray(user.authen)
        ? user.authen.flatMap(a => Array.isArray(a?.roles) ? a.roles : [])
        : [];
      return allRoles.map(r => typeof r==='string'?parseInt(r):r).filter(r=>Number.isFinite(r)).filter((v,i,arr)=>arr.indexOf(v)===i);
    },
    getRoleTitle(roleId) {
      const role = this.availableRoles.find(r => r.roleId === roleId);
      return role ? role.title : "Role " + roleId;
    },

    // ---------- Modal ----------
    openAddRoleModal(user) {
      this.modalUser = user;
      this.modalUserName = `${this.getFirstName(user)} (${this.getEmail(user)})`;
      this.selectedRole = null;
      this.showRoleModal = true;
    },
    closeRoleModal() {
      this.showRoleModal = false;
      this.modalUser = null;
      this.modalUserName = '';
      this.selectedRole = null;
    },
    async confirmAddRole() {
      if (!this.selectedRole || !this.modalUser) return;
      const user = this.modalUser;
      const roleId = this.selectedRole;

      if (!user.authen) user.authen = [{}];
      if (!user.authen[0].roles) user.authen[0].roles = [];

      const roles = this.getRoles(user);
      if (roles.includes(roleId)) {
        await Swal.fire({ icon: 'warning', title: 'มี Role นี้แล้ว', text: 'Role นี้มีอยู่แล้ว' });
        return;
      }

      const authIndex = Array.isArray(user.authen) ? user.authen.findIndex(a => a && a._id) : 0;
      const indexToUse = authIndex >=0 ? authIndex : 0;
      const currentRoles = Array.isArray(user.authen[indexToUse].roles) ? user.authen[indexToUse].roles : [];
      const newRoles = [...currentRoles.map(r => r!=null?r.toString():''), roleId.toString()].filter((v,i,arr)=>v&&arr.indexOf(v)===i);
      const setPath = `authen.${indexToUse}.roles`;
      await this.$store.dispatch("Auth/updateUser", {_id: user._id, $set:{[setPath]: newRoles}});
      this.closeRoleModal();
      await this.fetchUsers();
    },

    // ---------- Remove Role ----------
    async removeRole(user, roleId) {
      if (!user.authen?.[0]?.roles) return;
      const authIndex = Array.isArray(user.authen) ? user.authen.findIndex(a => a && a._id) : 0;
      const indexToUse = authIndex>=0?authIndex:0;
      const currentRoles = Array.isArray(user.authen[indexToUse].roles)?user.authen[indexToUse].roles:[];
      const newRoles = currentRoles.filter(r => (r!=null?r.toString():'') !== roleId.toString());
      const setPath = `authen.${indexToUse}.roles`;
      await this.$store.dispatch("Auth/updateUser",{_id:user._id,$set:{[setPath]:newRoles}});
      await this.fetchUsers();
    },

    async deleteUserConfirm(user) {
      if(!user||!user._id) return;
      const result = await Swal.fire({
        title: 'ยืนยันการลบผู้ใช้',
        text: `ยืนยันการลบผู้ใช้?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ลบ',
        cancelButtonText: 'ยกเลิก'
      });
      if (!result.isConfirmed) return;
      await this.$store.dispatch("Auth/deleteUser",user._id);
      await this.fetchUsers();
      await Swal.fire({ icon: 'success', title: 'ลบเรียบร้อย' });
    }

    ,

    // ---------- Add User ----------
    openAddUserModal() {
      this.newUser = { firstName: '', email: '', password: '', role: null };
      this.showAddUserModal = true;
    },
    closeAddUserModal() {
      this.showAddUserModal = false;
      this.newUser = { firstName: '', email: '', password: '', role: null };
    },
    async confirmAddUser() {
      // basic validation
      if (!this.newUser.email) {
        await Swal.fire({ icon: 'warning', title: 'กรุณากรอกอีเมล' });
        return;
      }
      // build payload compatible with backend model: `userinfo.firstName` must be an array of {key,value}
      const firstNameArr = this.newUser.firstName ? [{ key: 'th', value: this.newUser.firstName }] : [];

      const payload = {
        email: this.newUser.email,
        // include both `userinfo` and `userInfo` casings because backend historically accepts both
        userinfo: { firstName: firstNameArr },
        userInfo: { firstName: firstNameArr },
        // Put credentials / login fields inside authen[0] so they are persisted
        authen: [{
          username: this.newUser.email,
          email: this.newUser.email,
          password: this.newUser.password || null,
          roles: this.newUser.role ? [String(this.newUser.role)] : []
        }]
      };

      try {
        await this.createUser(payload);
        await this.fetchUsers();
        this.closeAddUserModal();
        await Swal.fire({ icon: 'success', title: 'เพิ่มผู้ใช้งานเรียบร้อย' });
      } catch (err) {
        console.error(err);
        await Swal.fire({ icon: 'error', title: 'เกิดข้อผิดพลาด', text: (err && err.message) || 'เกิดข้อผิดพลาดขณะเพิ่มผู้ใช้งาน' });
      }
    },
  },
  watch: {
    users: {
      handler() { this.tableKey+=1; },
      deep:true
    }
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 1rem;
}
.form-group label {
  font-weight: 600;
  margin-bottom: 0.25rem;
  display: block;
}
.form-control {
  width: 100%;
  padding: 0.5rem;
  border-radius: 0.25rem;
  border: 1px solid #e9ecef;
}

::v-deep .modal-rounded .modal-content {
  border-radius: 1rem !important;
}
</style>
